import MDBox from "components/MDBox";
import React from "react";
import { useSelector } from "react-redux";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import "../../styles/home.scss";

import ManagerRoleView from "./components/ManagerRoleView";

function Home() {
  const user = useSelector((state) => state.loginUser.loginUserState);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ paddingBottom: "0rem" }}>{user.type === "user" && <ManagerRoleView />}</MDBox>
    </DashboardLayout>
  );
}

export default Home;
